import { PROJECT_BRANDS } from '@/modules/brand/domain/brand';
import { QUIZ_PRODUCT_TYPES } from '@/modules/product/domain/product';
import { REGIONS } from '@/modules/region/domain/region';
import * as upsells from '../domain/sequences';
const UPSELL_RULES = [
    // --- Reverse: upsells disabled — takes precedence over every rule below ---
    { brand: PROJECT_BRANDS.reverse, regions: [REGIONS.br], sequence: null },
    // --- Reverse: All-in-One (white) — US ---
    {
        brand: PROJECT_BRANDS.reverse,
        regions: [REGIONS.us],
        sequence: upsells.eNbZ8o,
    },
    // --- Reverse: region + productType ---
    {
        brand: PROJECT_BRANDS.reverse,
        regions: [REGIONS.au],
        productTypes: [
            QUIZ_PRODUCT_TYPES.fitnessPilates,
            QUIZ_PRODUCT_TYPES.fitnessAsianPilates,
            QUIZ_PRODUCT_TYPES.fitnessWalking,
            QUIZ_PRODUCT_TYPES.fitnessTaichi,
        ],
        sequence: upsells.Ajk2S0,
    },
    // --- Reverse: region only ---
    { brand: PROJECT_BRANDS.reverse, regions: [REGIONS.uk, REGIONS.join], sequence: upsells.bNp3KE },
    { brand: PROJECT_BRANDS.reverse, regions: [REGIONS.mx], sequence: upsells.ZXnRCF },
    { brand: PROJECT_BRANDS.reverse, regions: [REGIONS.eu], sequence: upsells.yeLWMM },
    {
        brand: PROJECT_BRANDS.reverse,
        regions: [REGIONS.au, REGIONS.ca, REGIONS.latam, REGIONS.sa],
        sequence: upsells.jdz8pH,
    },
    // --- MuscleCharge: region only ---
    { brand: PROJECT_BRANDS.muscleCharge, regions: [REGIONS.us], sequence: upsells.mCu5sP },
    {
        brand: PROJECT_BRANDS.muscleCharge,
        regions: [REGIONS.uk, REGIONS.join, REGIONS.eu, REGIONS.latam],
        sequence: upsells.APV6m8,
    },
];
const BRAND_DEFAULTS = {
    [PROJECT_BRANDS.reverse]: upsells.K7m6Xc,
    [PROJECT_BRANDS.muscleCharge]: null,
};
function matchesRule(rule, { brand, region, productType, pricingModel }) {
    if (rule.brand !== brand)
        return false;
    if (!rule.regions.includes(region))
        return false;
    if (rule.productTypes && !rule.productTypes.includes(productType))
        return false;
    if (rule.pricingModel && rule.pricingModel !== pricingModel)
        return false;
    return true;
}
export const getUpsellSequence = ({ productType, pricingModel, region, brand = PROJECT_BRANDS.reverse, }) => {
    const defaultSequence = BRAND_DEFAULTS[brand] ?? null;
    if (!region)
        return defaultSequence;
    const rule = UPSELL_RULES.find((r) => matchesRule(r, { brand, region, productType, pricingModel }));
    return rule ? rule.sequence : defaultSequence;
};
